import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profileUser: null,
  roles:null,
  permissions:[]
  
};

const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    setUserProfile: (state, action) => {
        
      state.user = action.payload;
      state.roles = action.payload?.role || "";
    
    },

    decrementUnReadUserCount: (state) => {
      if (state.user && typeof state.user.unReadUserCount === "number" && state.user.unReadUserCount > 0) {
        state.user.unReadUserCount -= 1;
      }
    },

    clearUserProfile: (state) => {
      state.user = null;
      state.roles = [];
      state.isAuthenticated = false;
    },
  },
});

export const { setUserProfile, clearUserProfile, decrementUnReadUserCount } = roleSlice.actions;

export default roleSlice.reducer;